
const SearchRequest = {
  "adultCount": 0,
  "childCount": 0,
  "infantCount": 0,
  "railTripType": 1,
  "originDestinationInformations": [
    {
      "departureDateTime": "string",
      "originCityCode": 0,
      "destinationCityCode": 0
    }
  ]
  };
 

  export default SearchRequest;
  